<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title" class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top" [title]="tooltipText">
        {{ title }}
    </div>

    <div *ngIf="!editOnly" class="dv-value" [ngClass]="{'hidden': isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <i *ngIf="iconClass" [class]="iconClass" class="m-r-sm"></i>

        <pre [class]="valueClass">{{ value || '-' }}</pre>

        <i *ngIf="!noEdit" class="fa fa-pencil pull-right"
           (click)="editModeOn()" data-toggle="tooltip" data-placement="top" title="Edit"></i>
    </div>

    <div class="dv-value" [ngClass]="{'hidden': !isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <textarea class="form-control" (keyup.enter)="apply()" [(ngModel)]="value" [attr.maxlength]="maxLength">
            {{value}}
        </textarea>

        <div *ngIf="!editOnly" class="m-t-xs apart-btns pull-right">
            <button type="button" class="apply" (click)="apply()">
                <i class="fa fa-check"></i>
            </button>

            <button type="button" class="reset" (click)="cancel()">
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/textarea-field/textarea-field.template.html